<div class="b-block" [ngClass]="active ? 'b-block_show-top' : sideview ? 'b-block_show-side' : 'b-block_show-front'">
  <div class="b-block__face b-block__face_front">{{ label }}</div>
  <div class="b-block__face b-block__face_right"></div>
  <div class="b-block__face b-block__face_back">B</div>
  <div class="b-block__face b-block__face_left">L</div>
  <div class="b-block__face b-block__face_top">T</div>
  <div class="b-block__face b-block__face_bottom">B</div>
</div>
